<template>
  <div>
    <div>
      <b-row>
        <b-col>
          <div>
            <b-card no-body>
              <b-tabs card>
                <b-tab title="Location Groups" active>
                  <b-card-text>
                    Saved Location Groups
                    <b-row><br /></b-row>
                    <b-table
                      sticky-header
                      id="LocationGroupTable"
                      :items="subgroupNames"
                      :fields="fields"
                      no-border-collapse
                      hover
                      show-empty
                      empty-text="You currently dont have any Location Groups of this type"
                      responsive
                      small
                    >
                      <template v-slot:cell(Edit)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="showEditModal(item, 'Edit')"
                        >
                          <BIconPencilSquare> </BIconPencilSquare>
                        </b-button>
                      </template>
                      <template v-slot:cell(Delete)="{ item }">
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          v-on:click="showDeleteModal(item, 'Location Group')"
                        >
                          <BIconXSquare> </BIconXSquare>
                        </b-button>
                      </template>
                    </b-table>

                    <b-button
                      v-b-toggle="'collapse-2'"
                      variant="outline-secondary"
                      class="m-1"
                      size="sm"
                    >
                      <BIconPlusSquare></BIconPlusSquare> Add New Location
                      Group</b-button
                    >

                    <!-- Element to collapse -->
                    <b-collapse id="collapse-2">
                      <b-card
                        ><b-row>
                          <b-col
                            ><b-form-group
                              id="Level1label"
                              label="Level 1 Group:"
                              label-for="Level1Select"
                              description="This should be your 1st level hierarchy"
                              ><b-form-select
                                id="Level1Select"
                                v-model="level1selected"
                                :options="level1options"
                              ></b-form-select> </b-form-group
                          ></b-col>
                          <b-col align-self="center"
                            ><b-button
                              variant="outline-secondary"
                              size="sm"
                              class="mb-2"
                              v-b-modal="'level1modal'"
                            >
                              <BIconPlusSquare></BIconPlusSquare> Add new option
                            </b-button></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col
                            ><b-form-group
                              id="Level2label"
                              label="Level 2 Group:"
                              label-for="Level2Select"
                              description="This should be your 2nd level hierarchy(if required)"
                              ><b-form-select
                                id="Level2Select"
                                v-model="level2selected"
                                :options="level2options"
                                size="sm"
                              ></b-form-select> </b-form-group
                          ></b-col>
                          <b-col align-self="center"
                            ><b-button
                              variant="outline-secondary"
                              size="sm"
                              class="mb-2"
                              v-b-modal="'level2modal'"
                            >
                              <BIconPlusSquare></BIconPlusSquare> Add new option
                            </b-button></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col
                            ><b-form-group
                              id="Level3label"
                              label="Level 3 Group:"
                              label-for="Level3Select"
                              description="This should be your 3rd level hierarchy(if required)"
                              ><b-form-select
                                id="Level3Select"
                                v-model="level3selected"
                                :options="level3options"
                                size="sm"
                              ></b-form-select> </b-form-group
                          ></b-col>
                          <b-col align-self="center"
                            ><b-button
                              variant="outline-secondary"
                              size="sm"
                              class="mb-2"
                              v-b-modal="'level3modal'"
                            >
                              <BIconPlusSquare></BIconPlusSquare> Add new option
                            </b-button></b-col
                          >
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-form-group
                              label="SubGroup Name:"
                              label-for="subname"
                            >
                              <b-form-input
                                v-model="SubgroupName"
                                id="subname"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="6" class="text-center"
                            ><b-button
                              v-on:click="SaveSubGroup()"
                              variant="info"
                              >Save</b-button
                            ></b-col
                          >
                          <b-col cols="6" class="text-center">
                            <b-button
                              variant="secondary"
                              v-b-toggle="'collapse-2'"
                              >Cancel</b-button
                            ></b-col
                          >
                        </b-row>
                      </b-card>
                    </b-collapse>
                  </b-card-text>
                </b-tab>
                <b-tab lazy title="Level 1 Filter Options">
                  <b-card-text>
                    Level 1 Filters
                    <b-row><br /></b-row>
                    <b-table
                      sticky-header
                      id="C1Table"
                      :items="SubgroupLvl1Names"
                      :fields="subfields"
                      no-border-collapse
                      hover
                      show-empty
                      empty-text="You currently dont have any Location Groups of this type"
                      responsive
                      small
                    >
                      <template v-slot:cell(Edit)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="showEditLvl1Modal(item, 'Edit')"
                        >
                          <BIconPencilSquare> </BIconPencilSquare>
                        </b-button>
                      </template>
                      <template v-slot:cell(Delete)="{ item }">
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          v-on:click="showDeleteModal(item, 'Level1')"
                        >
                          <BIconXSquare> </BIconXSquare>
                        </b-button>
                      </template>
                    </b-table>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      v-b-modal="'level1modal'"
                    >
                      <BIconPlusSquare></BIconPlusSquare> Add new Level 1 Filter
                    </b-button>
                  </b-card-text>
                </b-tab>
                <b-tab lazy title="Level 2 Filter Options">
                  <b-card-text>
                    Level 2 Filters
                    <b-row><br /></b-row>
                    <b-table
                      sticky-header
                      id="C2Table"
                      :items="SubgroupLvl2Names"
                      :fields="subfields"
                      no-border-collapse
                      hover
                      show-empty
                      empty-text="You currently dont have any Location Groups of this type"
                      responsive
                      small
                    >
                      <template v-slot:cell(Edit)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="showEditLvl2Modal(item, 'Edit')"
                        >
                          <BIconPencilSquare> </BIconPencilSquare>
                        </b-button>
                      </template>
                      <template v-slot:cell(Delete)="{ item }">
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          v-on:click="showDeleteModal(item, 'Level1')"
                        >
                          <BIconXSquare> </BIconXSquare>
                        </b-button>
                      </template>
                    </b-table>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      v-b-modal="'level2modal'"
                    >
                      <BIconPlusSquare></BIconPlusSquare> Add new Level 2 Filter
                    </b-button>
                  </b-card-text>
                </b-tab>
                <b-tab lazy title="Level 3 Filter Options">
                  <b-card-text>
                    Level 3 Filters
                    <b-row><br /></b-row>
                    <b-table
                      sticky-header
                      id="C1Table"
                      :fields="subfields"
                      :items="SubgroupLvl3Names"
                      no-border-collapse
                      hover
                      show-empty
                      empty-text="You currently dont have any Location Groups of this type"
                      responsive
                      small
                    >
                      <template v-slot:cell(Edit)="{ item }">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          v-on:click="showEditLvl3Modal(item, 'Edit')"
                        >
                          <BIconPencilSquare> </BIconPencilSquare>
                        </b-button>
                      </template>
                      <template v-slot:cell(Delete)="{ item }">
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          v-on:click="showDeleteModal(item, 'Level1')"
                        >
                          <BIconXSquare> </BIconXSquare>
                        </b-button>
                      </template>
                    </b-table>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      v-b-modal="'level3modal'"
                    >
                      <BIconPlusSquare></BIconPlusSquare> Add new Level 3 Filter
                    </b-button>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-tooltip target="Level1label" triggers="hover" placement="left"
      >Level 1 groups could be separate buildings/floors/water supplies within
      location.</b-tooltip
    >
    <b-tooltip target="Level2label" triggers="hover" placement="left"
      >Level 2 groups could be floors/zones within level 1 groups.</b-tooltip
    >
    <b-tooltip target="Level3label" triggers="hover" placement="left"
      >Level 3 groups could be individual rooms or areas within level 2
      groups.</b-tooltip
    >
    <b-modal
      id="subgroupedit"
      ref="subgroupedit"
      title="Location Groups"
      hide-footer
    >
      <b-col sm="12">
        <p>Original Name</p>
        <b-form-group
          id="subgroupeditlabel"
          label="Select subgroup to edit:"
          label-for="SubgroupEditSelect"
          v-if="EditSubgroupData.Edit != true"
          ><b-form-select
            id="SubgroupEditSelect"
            v-model="subgroupeditselected"
            :options="subgroupoptions"
          ></b-form-select>
        </b-form-group>
        <b-form-input
          id="subgroupedit"
          size="sm"
          v-model="EditSubgroupData.Name"
          placeholder="Edit Name"
          readonly
          v-if="EditSubgroupData.Edit == true"
        ></b-form-input>
        <br />
        <p>New Name</p>
        <b-form-input
          id="subgroupedit"
          size="sm"
          placeholder="Edit Name"
          v-model="subgroupeditselectedNewName"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="subgroupeditcheck"
          v-model="subgroupeditcheck"
          name="subgroupeditcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm edit to Location Group
        </b-form-checkbox>
      </b-col>
      <br />
      <b-col sm="12">
        <b-button variant="outline-secondary" v-on:click="newSubGroupName()">
          Submit new name
        </b-button>
      </b-col>
    </b-modal>
    <b-modal
      id="subgroupremoval"
      ref="subgroupremoval"
      title="SubGroups"
      hide-footer
    >
      <p class="caution">
        By Choosing a filter below this will request removal of the filter from
        Seraph Protect System. Doing so could affect how devices and data is
        displayed. Please ensure that you have express permission prior to
        requesting removal of filter.
      </p>
      <b-col sm="12">
        <b-form-group
          id="subgroupdeletelabel"
          label="Choose Subgroup To Remove:"
          label-for="subgroupRemoval"
          description="Please Choose Subgroup to Request Deletion"
        >
          <b-form-input
            id="subgroupdelete"
            size="sm"
            v-model="DeleteSubgroupData.Name"
            placeholder="Name of Location Group"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-input
          id="subgroupremovereason"
          size="sm"
          placeholder="Enter reason for removal request"
          v-model="locationGroupRemovalReason"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="subgroupdeletemodalcheck"
          v-model="subgroupdeletemodalcheck"
          name="subgroupdeletemodalcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm Removal Request.
        </b-form-checkbox>
      </b-col>
      <br />
      <b-button
        variant="outline-secondary"
        v-on:click="requestSubgroupDeletion()"
      >
        Request Deletion
      </b-button>
    </b-modal>
    <b-modal id="level1modal" ref="level1modal" title="Level 1 Filters">
      <b-col sm="12">
        <b-form-input
          id="level1new"
          size="sm"
          placeholder="Enter new filter name"
          v-model="level1newFilterName"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level1modalcheck"
          v-model="level1modalcheck"
          name="level1modalcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm value to be added to Level 1 Filters
        </b-form-checkbox>
      </b-col>
      <br />
      <b-button variant="outline-secondary" v-on:click="AddNewFilter('1')">
        Add New Level 1 Filter
      </b-button>
    </b-modal>
    <b-modal
      id="level1edit"
      ref="level1edit"
      title="Level 1 Filters"
      hide-footer
    >
      <b-col sm="12">
        <b-form-group
          id="level1editlabel"
          label="Original Filter Name:"
          label-for="level1EditSelect"
          ><b-form-input
            id="level1EditSelect"
            size="sm"
            v-model="EditSubgroupData.Name"
            placeholder="Edit Name"
            readonly
          ></b-form-input>
        </b-form-group>
        <b-col><br /></b-col>
        <b-form-group
          id="level1editlabel"
          label="New Filter Name:"
          label-for="level1editnew"
        >
          <b-form-input
            id="level1editnew"
            size="sm"
            placeholder="Edit Name"
            v-model="level1NewName"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level1editcheck"
          v-model="level1editcheck"
          name="level1editcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm edit to Level 1 Filter
        </b-form-checkbox>
      </b-col>
      <b-col sm="12">
        <b-button variant="outline-secondary" v-on:click="editLevel1Filter()">
          Submit Edit
        </b-button>
      </b-col>
    </b-modal>
    <b-modal id="level1removal" title="Level 1 Filters" hide-footer>
      <p class="caution">
        By Choosing a filter below this will request removal of the filter from
        Seraph Protect System. Doing so could affect how devices and data is
        displayed. Please ensure that you have express permission prior to
        requesting removal of filter.
      </p>
      <b-col sm="12">
        <b-form-group
          id="Level1deletelabel"
          label="Choose Filter To Remove:"
          label-for="Level1Removal"
          description="Please Choose Filter to Request Deletion"
          ><b-form-select
            id="Level1Removal"
            v-model="level1removal"
            :options="level1options"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-input
          id="level1removereason"
          size="sm"
          placeholder="Enter reason for removal request"
          v-model="level1deletemodalReason"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level1deletemodalcheck"
          v-model="level1deletemodalcheck"
          name="level1deletemodalcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm Removal Request.
        </b-form-checkbox>
      </b-col>
      <b-button v-on:click="deleteFilter('1')" variant="outline-danger">
        Delete Filter
      </b-button>
    </b-modal>
    <b-modal id="level2modal" ref="level2modal" title="Level 2 Filters"
      ><b-col sm="12">
        <b-form-input
          id="level2new"
          size="sm"
          placeholder="Enter new filter name"
          v-model="level2newFilterName"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level2modalcheck"
          v-model="level2modalcheck"
          name="level2modalcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm value to be added to Level 2 Filters
        </b-form-checkbox>
      </b-col>
      <br />
      <b-button variant="outline-secondary" v-on:click="AddNewFilter('2')">
        Add New Level 2 Filter
      </b-button></b-modal
    >
    <b-modal
      id="level2edit"
      ref="level2edit"
      title="Level 2 Filters"
      hide-footer
    >
      <b-col sm="12">
        <b-form-group
          id="level1editlabel"
          label="Original Filter Name:"
          label-for="level1EditSelect"
          ><b-form-input
            id="level2EditSelect"
            size="sm"
            v-model="EditSubgroupData.Name"
            placeholder="Edit Name"
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-input
          id="level2edit"
          size="sm"
          placeholder="Edit Name"
          v-model="level2NewName"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level2editcheck"
          v-model="level2editcheck"
          name="level2editcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm edit to Level 2 Filter
        </b-form-checkbox>
      </b-col>
      <b-col sm="12">
        <b-button variant="outline-secondary" v-on:click="editLevel2Filter()"
          >Submit Edit</b-button
        >
      </b-col>
    </b-modal>
    <b-modal id="level2removal" title="Level 2 Filters" hide-footer>
      <p class="caution">
        By Choosing a filter below this will request removal of the filter from
        Seraph Protect System. Doing so could affect how devices and data is
        displayed. Please ensure that you have express permission prior to
        requesting removal of filter.
      </p>
      <b-col sm="12">
        <b-form-group
          id="Level2deletelabel"
          label="Choose Filter To Remove:"
          label-for="Level2Removal"
          description="Please Choose Filter to Request Deletion"
          ><b-form-select
            id="Level2Removal"
            v-model="level2removal"
            :options="level2options"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-input
          id="level2removereason"
          size="sm"
          placeholder="Enter reason for removal request"
          v-model="level2deletemodalReason"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level2deletemodalcheck"
          v-model="level2deletemodalcheck"
          name="level2deletemodalcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm Removal Request.
        </b-form-checkbox>
      </b-col>
      <b-button v-on:click="deleteFilter('2')" variant="outline-danger">
        Delete Filter
      </b-button>
    </b-modal>
    <b-modal
      id="level3modal"
      ref="level3modal"
      title="Level 3 Filters"
      hide-footer
      ><b-col sm="12">
        <b-form-input
          id="level3new"
          size="sm"
          placeholder="Enter new filter name"
          v-model="level3newFilterName"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level3modalcheck"
          v-model="level3modalcheck"
          name="level3modalcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm value to be added to Level 3 Filters
        </b-form-checkbox>
      </b-col>
      <br />
      <b-button variant="outline-secondary" v-on:click="AddNewFilter('3')">
        Add New Level 3 Filter
      </b-button>
    </b-modal>
    <b-modal
      id="level3edit"
      ref="level3edit"
      title="Level 3 Filters"
      hide-footer
    >
      <b-col sm="12">
        <b-form-group
          id="level1editlabel"
          label="Original Filter Name:"
          label-for="level1EditSelect"
          ><b-form-input
            id="level3EditSelect"
            size="sm"
            v-model="EditSubgroupData.Name"
            placeholder="Edit Name"
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-input
          id="level3edit"
          size="sm"
          placeholder="Edit Name"
          v-model="level3NewName"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level3editcheck"
          v-model="level3editcheck"
          name="level3editcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm edit to Level 3 Filter
        </b-form-checkbox>
      </b-col>
      <b-col sm="12">
        <b-button variant="outline-secondary" v-on:click="editLevel3Filter()"
          >Submit Edit
        </b-button>
      </b-col>
    </b-modal>
    <b-modal id="level3removal" title="Level 3 Filters" hide-footer>
      <p class="caution">
        By Choosing a filter below this will request removal of the filter from
        Seraph Protect System. Doing so could affect how devices and data is
        displayed. Please ensure that you have express permission prior to
        requesting removal of filter.
      </p>
      <b-col sm="12">
        <b-form-group
          id="Level3deletelabel"
          label="Choose Filter To Remove:"
          label-for="Level3Removal"
          description="Please Choose Filter to Request Deletion"
          ><b-form-select
            id="Level3Removal"
            v-model="level3removal"
            :options="level3options"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-input
          id="level3removereason"
          size="sm"
          placeholder="Enter reason for removal request"
          v-model="level3deletemodalReason"
        ></b-form-input>
      </b-col>
      <b-row><br /></b-row>
      <b-col sm="12">
        <b-form-checkbox
          id="level3deletemodalcheck"
          v-model="level3deletemodalcheck"
          name="level3deletemodalcheck"
          value="Confirmed"
          unchecked-value="not_Confirmed"
        >
          Confirm Removal Request.
        </b-form-checkbox>
      </b-col>
      <b-button v-on:click="deleteFilter('3')" variant="outline-danger">
        Delete Filter
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import {
  BIconPlusSquare,
  BIconPencilSquare,
  BIconXSquare,
} from "bootstrap-vue";

export default {
  computed: {},
  components: {
    BIconPlusSquare,
    BIconPencilSquare,
    BIconXSquare,
  },

  data() {
    return {
      level1modalcheck: "",
      level2modalcheck: "",
      level3modalcheck: "",
      level1newFilterName: "",
      level2newFilterName: "",
      level3newFilterName: "",
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,
      fields: [
        { key: "Name", variant: "primary" },
        { key: "Level_1" },
        { key: "Level_2" },
        { key: "Level_3" },
        { key: "Edit" },
        { key: "Delete" },
      ],
      subfields: [
        { key: "Name", variant: "primary" },
        { key: "Edit" },
        { key: "Delete" },
      ],
      items: [],
      subgroupoptions: [],
      level1options: [],
      level2options: [],
      level3options: [],
      selectedlocation: localStorage.getItem("CurrentLocation"),
      level3selected: "",
      level2selected: "",
      level1selected: "",
      SubgroupName: "",
      subgroupNames: [],
      subgroupeditselectedNewName: "",
      SubgroupLvl1Names: [],
      SubgroupLvl2Names: [],
      SubgroupLvl3Names: [],
      level3deletemodalcheck: "",
      level3removal: "",
      level3editcheck: "",
      level3editselected: "",
      level2deletemodalcheck: "",
      level2removal: "",
      level2editcheck: "",
      level2editselected: "",
      level1deletemodalcheck: "",
      level1removal: "",
      level1editcheck: "",
      level1editselected: "",
      subgroupdeletemodalcheck: "",
      subgroupremoval: "",
      subgroupeditcheck: "",
      subgroupeditselected: "",
      selected: "",
      level1NewName: "",
      level2NewName: "",
      level3NewName: "",
      level1deletemodalReason: "",
      level2deletemodalReason: "",
      level3deletemodalReason: "",
      EditSubgroupData: "",
      DeleteSubgroupData: "",
      locationGroupRemovalReason: "",
      DeleteSubgroupType: "",
      userName: localStorage.getItem("fullname"),
      currentLocation: localStorage.getItem("CurrentLocation"),
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LocationSubgroup",
      LocationDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        this.subgroupoptions = [];
        let MainSubgroup = response.data.Values;

        for (let i = 0; i < MainSubgroup.length; i++) {
          let Level1Var = "--";
          let Level2Var = "--";
          let Level3Var = "--";
          if (MainSubgroup[i][1] != null) {
            Level1Var = MainSubgroup[i][1];
          }
          if (MainSubgroup[i][2] != null) {
            Level2Var = MainSubgroup[i][2];
          }
          if (MainSubgroup[i][3] != null) {
            Level3Var = MainSubgroup[i][3];
          }
          this.subgroupNames.push({
            Name: MainSubgroup[i][0],
            Level_1: Level1Var,
            Level_2: Level2Var,
            Level_3: Level3Var,
            Edit: "",
            Delete: "",
          });
          this.subgroupoptions.push({
            value: MainSubgroup[i][0],
            text: MainSubgroup[i][0],
          });
        }
      });

    let LookUpUrl1 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders1 = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LocationSubgroupList",
      LocationDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };

    axios
      .post(LookUpUrl1, this.LookUpRequest, LookUpHeaders1)
      .then((response) => {
        let SubGroupLvl1 = response.data.Values[1];
        let SubGroupLvl2 = response.data.Values[2];
        let SubGroupLvl3 = response.data.Values[3];

        for (let i = 0; i < SubGroupLvl1.length; i++) {
          this.SubgroupLvl1Names.push({
            Name: SubGroupLvl1[i],
            Edit: "",
            Delete: "",
          });
          this.level1options.push({
            value: SubGroupLvl1[i],
            text: SubGroupLvl1[i],
          });
        }
        for (let i = 0; i < SubGroupLvl2.length; i++) {
          this.SubgroupLvl2Names.push({
            Name: SubGroupLvl2[i],
            Edit: "",
            Delete: "",
          });
          this.level2options.push({
            value: SubGroupLvl2[i],
            text: SubGroupLvl2[i],
          });
        }
        for (let i = 0; i < SubGroupLvl3.length; i++) {
          this.SubgroupLvl3Names.push({
            Name: SubGroupLvl3[i],
            Edit: "",
            Delete: "",
          });
          this.level3options.push({
            value: SubGroupLvl3[i],
            text: SubGroupLvl3[i],
          });
        }
      });
  },

  methods: {
    requestSubgroupDeletion() {
      if (
        (this.locationGroupRemovalReason != "") &
        (this.subgroupdeletemodalcheck == "Confirmed")
      ) {
        let newMessage = "Hello";
        let newMessage2 = "";
        let newMessageToString = this.locationGroupRemovalReason;
        newMessage = JSON.stringify(newMessageToString);
        newMessage2 = newMessage.replace(/^"|"$/g, "");
        let EmailHPAdd = {
          ToEmail: "support@seraphprotect.online",
          EmailText:
            "Hello, \\n\\nThe following User has requested a location group deletion. \\n\\nPlease follow up with the appropriate steps.\\nFull Name: " +
            this.userName +
            "\\nReason for deletion: " +
            newMessage2 +
            "\\nLocation: " +
            this.currentLocation +
            "\\nLocation Groups to Delete: " +
            this.DeleteSubgroupData.Name +
            "\\nLevel of Location Group: " +
            this.DeleteSubgroupType +
            "\\n\\nSent from Seraph Protect",
          EmailSubject: "Delete Location Group ",
        };
        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";
        let EmailPostHeaders = this.$apikeyPost;
        axios
          .post(EmailPosturl, EmailHPAdd, EmailPostHeaders)
          .then((response) => {
            response;
            this.locationGroupRemovalReason = "";
            this.subgroupdeletemodalcheck = "";
            this.$refs["subgroupremoval"].hide();
            this.resetFilters();
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Removal Request has been submitted, system will be updated accordingly. "
        );
      }
    },

    showDeleteModal(Data, Type) {
      this.DeleteSubgroupData = Data;
      this.DeleteSubgroupData.Delete = true;
      this.DeleteSubgroupType = Type;
      this.$refs["subgroupremoval"].show();
    },

    showEditModal(Data) {
      this.EditSubgroupData = Data;
      this.EditSubgroupData.Edit = true;
      this.$refs["subgroupedit"].show();
    },

    showEditLvl3Modal(Data) {
      this.EditSubgroupData = Data;
      this.EditSubgroupData.Edit = true;

      this.$refs["level3edit"].show();
    },

    showEditLvl2Modal(Data) {
      this.EditSubgroupData = Data;
      this.EditSubgroupData.Edit = true;

      this.$refs["level2edit"].show();
    },

    showEditLvl1Modal(Data) {
      this.EditSubgroupData = Data;
      this.EditSubgroupData.Edit = true;

      this.$refs["level1edit"].show();
    },

    deleteFilter(Level) {
      Level;
      let filterToRemove = "";

      let newMessage = "";
      let newMessage2 = "";
      let newMessageToString = "";

      if ((this.level1removal != "") & (this.level1deletemodalcheck != "")) {
        filterToRemove = this.level1removal;
        newMessageToString = this.level1deletemodalReason;
      }
      if ((this.level2removal != "") & (this.level2deletemodalcheck != "")) {
        filterToRemove = this.level2removal;
        newMessageToString = this.level2deletemodalReason;
      }
      if ((this.level3removal != "") & (this.level3deletemodalcheck != "")) {
        filterToRemove = this.level3removal;
        newMessageToString = this.level3deletemodalReason;
      }

      if (filterToRemove != "") {
        newMessage = JSON.stringify(newMessageToString);
        newMessage2 = newMessage.replace(/^"|"$/g, "");
        let EmailHPAdd = {
          ToEmail: "support@seraphprotect.online",
          EmailText:
            "Hello, \\n\\nThe following User has requested a filter deletion. \\n\\nPlease follow up with the appropriate steps.\\nFull Name: " +
            this.userName +
            "\\nReason for deletion: " +
            newMessage2 +
            "\\nSubgroup to Delete: " +
            filterToRemove +
            "\\n\\nSent from Seraph Protect",
          EmailSubject: "Delete Location Subgroup ",
        };
        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";
        let EmailPostHeaders = this.$apikeyPost;
        axios
          .post(EmailPosturl, EmailHPAdd, EmailPostHeaders)
          .then((response) => {
            response;
            alert("hide modal");
          })
          .catch((err) => {
            "Error: ===", err;
          });
      }
    },

    resetFilters() {
      (this.level1newFilterName = ""),
        (this.level2newFilterName = ""),
        (this.level3newFilterName = ""),
        (this.subgroupdeletemodalcheck = "not_Confirmed");
      this.subgroupeditcheck = "not_Confirmed";
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LocationSubgroup",
        LocationDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          this.subgroupoptions = [];
          this.subgroupNames = [];
          let MainSubgroup = response.data.Values;

          for (let i = 0; i < MainSubgroup.length; i++) {
            this.subgroupNames.push({
              Name: MainSubgroup[i][0],
              Level_1: MainSubgroup[i][1],
              Level_2: MainSubgroup[i][2],
              Level_3: MainSubgroup[i][3],
            });
            this.subgroupoptions.push({
              value: MainSubgroup[i][0],
              text: MainSubgroup[i][0],
            });
          }
        });

      let LookUpUrl1 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders1 = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LocationSubgroupList",
        LocationDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };

      axios
        .post(LookUpUrl1, this.LookUpRequest, LookUpHeaders1)
        .then((response) => {

          this.SubgroupLvl1Names = [];
          this.level1options = [];

          this.SubgroupLvl2Names = [];
          this.level2options = [];

          this.SubgroupLvl3Names = [];
          this.level3options = [];

          let SubGroupLvl1 = response.data.Values[1];
          let SubGroupLvl2 = response.data.Values[2];
          let SubGroupLvl3 = response.data.Values[3];

          for (let i = 0; i < SubGroupLvl1.length; i++) {
            this.SubgroupLvl1Names.push({
              Name: SubGroupLvl1[i],
              Edit: "",
              Delete: "",
            });
            this.level1options.push({
              value: SubGroupLvl1[i],
              text: SubGroupLvl1[i],
            });
          }
          for (let i = 0; i < SubGroupLvl2.length; i++) {
            this.SubgroupLvl2Names.push({
              Name: SubGroupLvl2[i],
              Edit: "",
              Delete: "",
            });
            this.level2options.push({
              value: SubGroupLvl2[i],
              text: SubGroupLvl2[i],
            });
          }
          for (let i = 0; i < SubGroupLvl3.length; i++) {
            this.SubgroupLvl3Names.push({
              Name: SubGroupLvl3[i],
              Edit: "",
              Delete: "",
            });
            this.level3options.push({
              value: SubGroupLvl3[i],
              text: SubGroupLvl3[i],
            });
          }
        });
    },

    editLevel1Filter() {
      if ((this.level1editcheck == "Confirmed") & (this.level1NewName != "")) {
        let LookUpUrlO1 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersO1 = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "EditSubgroupLevel1Name",
          LocationDict: [
            {
              NewLevel1Name: this.level1NewName,
              Level1Name: this.EditSubgroupData.Name,
            },
          ],
        };

        axios
          .post(LookUpUrlO1, this.LookUpRequest, LookUpHeadersO1)
          .then((response) => {
            response;
            this.SubgroupLvl1Names = [];
            this.$refs["level1edit"].hide();

            this.resetFilters();
          });
      } else if (
        (this.level1editcheck != "Confirmed") &
        (this.level1NewName == "")
      ) {
        alert("Please ensure all fields are correctly filled");
      }
    },
    editLevel2Filter() {
      if ((this.level2editcheck == "Confirmed") & (this.level2NewName != "")) {
        let LookUpUrlO1 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersO1 = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "EditSubgroupLevel2Name",
          LocationDict: [
            {
              NewLevel2Name: this.level2NewName,
              Level2Name: this.EditSubgroupData.Name,
            },
          ],
        };

        axios
          .post(LookUpUrlO1, this.LookUpRequest, LookUpHeadersO1)
          .then((response) => {
            response;
            alert("Subgroup filter updated");
            // level2edit
            this.$refs["level2edit"].hide();
            this.resetFilters();
          });
      } else if (
        this.level2editcheck != "Confirmed" ||
        this.level2NewName == ""
      ) {
        alert("Please ensure all fields are filled");
      }
    },
    editLevel3Filter() {
      if ((this.level3NewName != "") & (this.level3editcheck == "Confirmed")) {
        let LookUpUrlO1 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersO1 = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "EditSubgroupLevel3Name",
          LocationDict: [
            {
              NewLevel3Name: this.level3NewName,
              Level3Name: this.EditSubgroupData.Name,
            },
          ],
        };

        axios
          .post(LookUpUrlO1, this.LookUpRequest, LookUpHeadersO1)
          .then((response) => {
            response;
            this.$refs["level3edit"].hide();

            this.resetFilters();
          });
      } else if (
        this.level3newFilterName == "" ||
        this.level3editcheck != "Confirmed"
      ) {
        alert("Please ensure all fields are filled before submitting");
      }
    },
    newSubGroupName() {
      if (
        (this.subgroupeditcheck == "Confirmed") &
        (this.subgroupeditselectedNewName != "")
      ) {
        let LookUpUrlO1 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersO1 = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "EditSubgroupName",
          LocationDict: [
            {
              SubGroupName: this.EditSubgroupData.Name,
              NewSubGroupName: this.subgroupeditselectedNewName,
            },
          ],
        };

        axios
          .post(LookUpUrlO1, this.LookUpRequest, LookUpHeadersO1)
          .then((response) => {
            response;
            this.$refs["subgroupedit"].hide();
            this.subgroupeditselectedNewName = "";
            this.resetFilters();
          });
      } else if (this.subgroupeditcheck != "Confirmed") {
        alert("Please confirm this edit using the checkbox");
      } else if (this.subgroupeditselectedNewName != "") {
        alert("Please ensure the new name is not empty before submitting");
      }
    },

    AddNewFilter(Level) {
      if (Level == "1") {
        this.level1options.push({
          value: this.level1newFilterName,
          text: this.level1newFilterName,
        });
        this.$refs["level1modal"].hide();
      }
      if (Level == "2") {
        this.level2options.push({
          value: this.level2newFilterName,
          text: this.level2newFilterName,
        });
        this.$refs["level2modal"].hide();
      }
      if (Level == "3") {
        this.level3options.push({
          value: this.level3newFilterName,
          text: this.level3newFilterName,
        });
        this.$refs["level3modal"].hide();

        // level3modal
      }

      let LookUpUrlO1 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeadersO1 = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "AddSubgroupFilter",
        LocationDict: [
          {
            Location: this.selectedlocation,
            Level1: this.level1newFilterName,
            Level2: this.level2newFilterName,
            Level3: this.level3newFilterName,
          },
        ],
      };

      axios
        .post(LookUpUrlO1, this.LookUpRequest, LookUpHeadersO1)
        .then((response) => {
          response;
          this.resetFilters();
        });
    },
    SaveSubGroup() {
      if (this.SubgroupName != "") {
        let LookUpUrlO1 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersO1 = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "CreateSubgroup",
          LocationDict: [
            {
              Location: this.selectedlocation,
              SubGroupName: this.SubgroupName,
              Level1: this.level1selected,
              Level2: this.level2selected,
              Level3: this.level3selected,
            },
          ],
        };

        axios
          .post(LookUpUrlO1, this.LookUpRequest, LookUpHeadersO1)
          .then((response) => {
            response,
              (this.SubGroupName = ""),
              (this.level1selected = ""),
              (this.level2selected = ""),
              (this.level3selected = ""),
              this.$root.$emit("bv::toggle::collapse", "collapse-2"),
              this.$emit("LocGEvent", this.SubgroupName);
            this.refreshTable();
          });
      } else {
        alert("Ensure Location Groups have a name");
      }
    },

    refreshTable() {
      this.SubgroupName = "";
      this.level1selected = "";
      this.level2selected = "";
      this.level3selected = "";
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LocationSubgroup",
        LocationDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          this.subgroupoptions = [];
          this.subgroupNames = [];
          let MainSubgroup = response.data.Values;

          for (let i = 0; i < MainSubgroup.length; i++) {
            let Level1Var = "--";
            let Level2Var = "--";
            let Level3Var = "--";
            if (MainSubgroup[i][1] != null) {
              Level1Var = MainSubgroup[i][1];
            }
            if (MainSubgroup[i][2] != null) {
              Level2Var = MainSubgroup[i][2];
            }
            if (MainSubgroup[i][3] != null) {
              Level3Var = MainSubgroup[i][3];
            }
            this.subgroupNames.push({
              Name: MainSubgroup[i][0],
              Level_1: Level1Var,
              Level_2: Level2Var,
              Level_3: Level3Var,
              Edit: "",
              Delete: "",
            });
            this.subgroupoptions.push({
              value: MainSubgroup[i][0],
              text: MainSubgroup[i][0],
            });
          }
        });
    },
  },
};
</script>

<style>
#Table {
  margin: auto;
  text-align: center;
}

.modal {
  text-align: center;
}

.caution {
  color: red;
}
</style>
